<div class="rectangular-selection-container">
    <div class="button-container">
        <button (click)="displayForm()" type="button" class="rectangle-selection-button">
            <div class="chevrons">
                <ng-container *ngIf="formIsVisible; then chevronDown"></ng-container>
                <ng-container *ngIf="!formIsVisible; then chevronRight"></ng-container>
                <ng-template #chevronRight>
                    <img src="../../../../assets/icons/chevron-right.svg" alt="chevron up" />
                </ng-template>
                <ng-template #chevronDown>
                    <img src="../../../../assets/icons/chevron-down.svg" alt="chevron down" />
                </ng-template>
            </div>
            Rectangle selection
        </button>
    </div>
    <form
        class="rectangular-selection-form"
        [formGroup]="rectangularSelectionForm"
        (ngSubmit)="selectData()"
        *ngIf="formIsVisible"
    >
        <div class="flex-row">
            <label for="xStart" class="number-input-label">x-Start</label>
            <input
                id="xStart"
                class="number-input-no-arrow"
                placeholder="x-Start"
                type="number"
                [formControlName]="X_START"
            />
            <label for="xEnd" class="number-input-label">x-End</label>
            <input
                id="xEnd"
                class="number-input-no-arrow"
                placeholder="x-End"
                type="number"
                [formControlName]="X_END"
            />
        </div>
        <div class="flex-row">
            <label for="yStart" class="number-input-label">y-Start</label>
            <input
                id="yStart"
                class="number-input-no-arrow"
                placeholder="y-Start"
                type="number"
                [formControlName]="Y_START"
            />
            <label for="yEnd" class="number-input-label">y-End</label>
            <input
                id="yEnd"
                class="number-input-no-arrow"
                placeholder="y-End"
                type="number"
                [formControlName]="Y_END"
            />
        </div>
        <div class="submit-button">
            <cds-button [disabled]="rectangularSelectionForm.invalid" size="sm" type="submit"
                >Select
            </cds-button>
            <cds-button size="sm" action="outline" type="button" (click)="resetFrom()"
                >Reset
            </cds-button>
        </div>
    </form>
</div>
